const DASHBOARD_BY_ROLE = [
  ['SUPER_ADMIN', '/super-admin'],
  ['ADMIN', '/admin-dashboard'],
  ['ADMINISTRATION', '/administration-dashboard'],
  ['PROJECT_ENGINEER', '/engineer-dashboard'],
  ['PROCUREMENT', '/procurement-dashboard'],
  ['STORE', '/store-dashboard'],
  ['ACCOUNT', '/account-dashboard'],
];

export const getDashboardRoute = (user) => {
  if (user?.isSuperAdmin) return '/super-admin';
  const roles = user?.roles || [];
  return DASHBOARD_BY_ROLE.find(([role]) => roles.includes(role))?.[1] || '/pending-approval';
};
